export default __webpack_public_path__ + "static/media/dmc-white-logo.e7ce6b19.png";